"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HORIZONTAL = exports.VERTICAL = void 0;
var VERTICAL = 'vertical';
exports.VERTICAL = VERTICAL;
var HORIZONTAL = 'horizontal';
exports.HORIZONTAL = HORIZONTAL;


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll-parallax/cjs/constants.js
// module id = 65
// module chunks = 0